import moment from 'moment-timezone';
import isArray from 'lodash/isArray';

export const columnCreatedAt = {
  path: 'createdAt',
  title: 'Created At',
  sort: 'created',
  render: (record) => (
    moment(record.createdAt).calendar(null, {
      sameElse: 'lll',
    })
  ),
};

export const columnUpdatedAt = {
  path: 'updatedAt',
  title: 'Updated At',
  sort: 'updated',
  render: record => (
    moment(record.updatedAt).calendar(null, {
      sameElse: 'lll',
    })
  ),
};

export const filterSortCreatedUpdated = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    updatedDesc: { updatedAt: -1 },
    updatedAsc: { updatedAt: 1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Date Created',
      value: 'createdDesc',
    }, {
      label: '↑ Date Created',
      value: 'createdAsc',
    }, {
      label: '↓ Date Updated',
      value: 'updatedDesc',
    }, {
      label: '↑ Date Updated',
      value: 'updatedAsc',
    }],
  }],
}];

export const filterSortCreatedUpdatedName = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    updatedDesc: { updatedAt: -1 },
    updatedAsc: { updatedAt: 1 },
    nameDesc: { name: 1 },
    nameAsc: { name: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Date Created',
      value: 'createdDesc',
    }, {
      label: '↑ Date Created',
      value: 'createdAsc',
    }, {
      label: '↓ Date Updated',
      value: 'updatedDesc',
    }, {
      label: '↑ Date Updated',
      value: 'updatedAsc',
    }, {
      label: '↓ Name',
      value: 'nameDesc',
    }, {
      label: '↑ Name',
      value: 'nameAsc',
    }],
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  col: 12,
  global: false,
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: value => (
    value && value.length
      ? value
      : undefined
  ),
  skip: [props => props.viewer?.role !== 'ADMIN'],
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Find By Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

export const filterStoreGlobal = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  col: 12,
  global: false,
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  skip: [
    props => (
      props.viewer?.role !== 'ADMIN'
      || props.searchParams.global !== 'any'
    ),
  ],
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Find By Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

export const filterGlobal = ['FilterField', {
  id: 'global',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    global: { store: { EQ: null } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('where', { ...filter.VALUES_MAP[value] })
      : value === 'any'
        ? null
        : builder.add('where', { ...filter.VALUES_MAP.global })
  ),
  getValueForField: value => (
    value && value.length
      ? value
      : 'global'
  ),
  skip: [
    props => (
      props.viewer?.role !== 'ADMIN'
    ),
  ],
  field: ['FieldRadio', {
    name: 'global',
    block: true,
    prepareValueForInput: value => (value ? value : 'global'),
    choices: [{
      label: 'Global',
      value: 'global',
    }, {
      label: 'All',
      value: 'any',
    }],
  }],
}];

export const filterSortHidden = ['FilterHidden', {
  id: 'sort',
  build: builder => builder.add('sort', { createdAt: -1 }),
}];

export const getValueForFieldDefault = value => (
  value && value.length
  ? value
  : undefined
);
